import React from "react";
import { Link } from "react-router-dom";

const MegaMenuCricket = ({ subcategories, category }) => {
  const width = `${240 * subcategories.length}px`;

  return (
    <div
      className="absolute mt-7 top-full left-1/2 transform -translate-x-1/2 bg-white z-50 shadow-lg border-b border-gray-200 px-6 py-1 text-sm "
      style={{
        width: width,
        height: "fit-content",
        display: "flex",
        gap: "20px", // optional for spacing between columns
      }}
    >
      {subcategories.map((sub) => (
        <div key={sub.name}>
          <h3 className="text-gray-500 text-sm mb-2 font-semibold">
            {sub.name}
          </h3>
          <ul
            className="space-y-0.1 text-black text-sm"
            style={{ marginTop: "6px" }}
          >
            {sub.children &&
              sub.children.length > 0 &&
              sub.children.map((child) => (
                <li key={child.id}>
                  <Link
                    to={`/${category.toLowerCase()}/${child.slug}`} // fixed template literal
                    className="block py-1 text-sm hover:text-red-600"
                  >
                    {child.name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default MegaMenuCricket;
